import { MenuItem } from '@common/generic/models/MenuItem';
import { constants } from '@common/constants';

export const MENU_ITEMS: MenuItem[] = [
  {
    text: 'Tests',
    links: ['runner'],
    roles: [
      constants.roles.SchemeAdmin,
      constants.roles.CttPartyAdmin,
      constants.roles.CttPartyUser
    ],
    class: 'fa fa-play-circle'
  },
  {
    text: 'Profiles',
    links: ['profiles'],
    roles: [constants.roles.SchemeAdmin],
    class: 'fa fa-list-ul'
  }
];
